import { render, staticRenderFns } from "./LinkAttachButton.vue?vue&type=template&id=f7fe61c6"
import script from "./LinkAttachButton.vue?vue&type=script&lang=js"
export * from "./LinkAttachButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports